// extracted by mini-css-extract-plugin
export default {"sidebarIcon":"Sidebar_sidebarIcon__z1x5z","iconSizeL":"Sidebar_iconSizeL__5UNab","iconSize":"Sidebar_iconSize__BJi7K","expanded":"Sidebar_expanded__HgpwZ"};